import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import AxiosInstance from "../Home/AxiosInstance";
import "./trainerPortal.css";

const TrainerAchievements = () => {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [achievementDate, setAchievementDate] = useState("");
  const navigate = useNavigate();

  const trainerId = localStorage.getItem("trainerId");

  const handleSubmit = async (e) => {
    e.preventDefault();

    const newAchievement = {
      trainer: trainerId,
      title,
      description,
      achievement_date: achievementDate,
    };

    try {
      const response = await AxiosInstance.post(
        "companies/user/achievements/",
        newAchievement
      );

      if (response.status === 201 || response.status === 200) {
        console.log("Achievement added:", response.data);
        navigate(-1); // Go back or close modal
      } else {
        console.error("Failed to create achievement:", response);
      }
    } catch (error) {
      console.error("Error creating achievement:", error);
    }
  };

  const closeModal = () => {
    navigate(-1);
  };

  return (
    <div
      style={{
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "1rem",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        zIndex: 1050,
      }}
    >
      <div className="container py-4">
        <div className="card mx-auto shadow" style={{ maxWidth: "480px" }}>
          <div className="card-header d-flex justify-content-between align-items-center">
            <h5 className="mb-0">Add Achievement</h5>
          </div>
          <form className="card-body" onSubmit={handleSubmit}>
            <div className="mb-3">
              <label htmlFor="title" className="form-label">
                Achievement Title
              </label>
              <input
                type="text"
                id="title"
                className="form-control"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                required
              />
            </div>

            <div className="mb-4">
              <label htmlFor="description" className="form-label">
                Description
              </label>
              <input
                type="text"
                id="description"
                className="form-control"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                required
              />
            </div>

            <div className="mb-3">
              <label htmlFor="achievementDate" className="form-label">
                Achievement Date
              </label>
              <input
                type="date"
                id="achievementDate"
                className="form-control"
                value={achievementDate}
                onChange={(e) => setAchievementDate(e.target.value)}
                required
              />
            </div>

            <div className="modal-footer px-0">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={closeModal}
              >
                Cancel
              </button>
              <button type="submit" className="btn btn-primary">
                Save
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default TrainerAchievements;
